<!-- 商品列表中的商品组件-->
<template>
  <div @click="toProductDetail(product.kkProductId)">
    <a :href="`/product-detail${product.productSeoSearchTerm}`"></a>
    <!-- PC端 -->
    <div class="product-single pointer kakaExposure" :data-exposure-kkproductid="product.kkProductId" :data-exposure-discountid="product.discountId" :data-exposure-location="kklocation" :data-type="reportType">
      <!-- 收藏按钮 -->
      <div v-if="isShowCollectionBut && showCollection && !isSoldOut">

        <el-popover v-if="isPC" placement="bottom-start" trigger="hover" popperClass="porduct-like">
          <div slot="reference" class="product-collection" :style="{ display: +this.product.collectStatus === 1 ? 'flex' : 'none', background: +this.product.collectStatus === 1 ? 'none' : 'rgba(0, 0, 0, 0.17)'}" @click.stop="collectionProduct">
            <i class="iconfont" :class="[+this.product.collectStatus === 1 ? 'icon-heart-3-fill' : 'icon-heart-3-line']"></i>
          </div>
          <div class="like-title">{{this.product.collectStatus === 1 ? 'Unfavorite Item' : 'Favorite Item' }}</div>
        </el-popover>
        <!-- <div v-else class="product-collection f" :style="{ background: +this.product.collectStatus === 1 ? 'none' : 'rgba(0, 0, 0, 0.17)'}" @click.stop="collectionProduct">
        <i class="iconfont" :class="[+this.product.collectStatus === 1 ? 'icon-heart-3-fill' : 'icon-heart-3-line']"></i>
      </div> -->
      </div>

      <!-- 新品 -->
      <div class="new-icon" v-if="isNew(product.upDate)">
        <span>{{ $t('Components.Product.New') }}</span>
      </div>
      <!-- 减免 -->
      <template v-else-if="product.discountType && product.discountType === 1">
        <div class="reduction-flash">
          <!-- <div style="width:22px;height:26px;background-image: url('https://img.kakaclo.com/web-img/index/Rectangle%20668.png');" class="f-c-c">
            <img src="https://img.kakaclo.com/web-img/index/Vector.png">
          </div> -->
          <span>{{ $t('Components.Product.Sale') }}</span>
        </div>
      </template>
      <!-- 减免 -->
      <div class="reduction" v-else-if="product.discountPercent || product.discountFixed">
        <div style="width:100%;height:100%" class="f-c-c">
          <span>{{product.discountRule == 2 ? '-$' : '-'}}<span style="font-weight:500">{{product.discountPercent || product.discountFixed}}</span>{{product.discountRule == 1 ? '%' : ''}}</span>
        </div>
      </div>

      <div class="product-img p-r">
        <oss-img :src="product.imgUrl || product.images" :width="252" :height="336" :isLazy="isLazy" :alt="product.productName" />
        <template v-if="published">
          <!-- 是否刊登 -->
          <div class="published">
            {{$t('customProduct.Published')}}
          </div>
          <!-- 刊登店铺列表 -->
          <div class="published-list">
            <div v-for="item in product.storeList" :key="item.id" class="published-item f--c">
              <img :src="icon[item.platformCode]">
              {{item.storeName}}
            </div>
          </div>
        </template>
        <div class="soldOut" v-if="isSoldOut">
          <!-- <el-button style="width:80%;margin: 0 auto;">Out of Stock</el-button> -->
          {{ $t('Components.Product.SoldOut') }}
        </div>
      </div>
      <div class="product-info" v-if="isShowInfo">
        <div class="product-name f--c" v-if="isShowName">
          <el-tooltip v-if="[1].includes(product.supplierLevel)" effect="dark" :offset="-20" :content="$t('inSrock.supplierRank')" placement="bottom-start">
            <img :src="require(`@/assets/img/productDetail/supplier_level${product.supplierLevel}.svg`)" class="supplier-level" alt="">
          </el-tooltip>
          <!-- <span v-if="isNew(product.upDate)" class="new-icon">{{ $t('Components.Product.New') }}</span> -->
          <div class="ellipsis">{{product.productName}}</div>
        </div>
        <div class="title-price f-b-c">
          <div style="width:100%">
            <template v-if="isPC">
              <div v-if="product.afterDiscountAmount >= 0" class="discount-price f--c f-b">
                <p class="price-with-discountPrice">
                  <el-tooltip effect="dark" :content="`Wholesale Price ${currencySymbol}${countCurrencyConversion(product.afterDiscountAmount)}`" placement="bottom-start">
                    <span class="wsp">WSP {{ currencySymbol }}{{product.afterDiscountAmount | currencyConversion}}</span>
                  </el-tooltip>
                  <span>{{ currencySymbol }}{{product.price || product.minPrice | currencyConversion}}</span>
                </p>
                <!-- <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                  <div class="f--c pointer">WSP <img class="lock" style="width:16px" src="@/assets/img/icon/lock.png" alt=""></div>
                </el-tooltip> -->
                <div v-if="isPC&&((showVolume&&product.discountType&& product.discountType !== 1) || $route.path === '/product-list')" class="salesVolume">{{product.salesVolume}} {{ $t('Components.Product.Sales') }}</div>
              </div>
              <template v-else>
                <p class="product-price f-b f--c">
                  <el-tooltip effect="dark" :content="`Wholesale Price ${currencySymbol}${countCurrencyConversion(product.price || product.minPrice)}`" placement="bottom-start">
                    <span>WSP {{ currencySymbol }}{{(product.price+'') || product.minPrice | currencyConversion}}</span>
                  </el-tooltip>
                  <!-- <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                    <div class="f--c pointer">WSP<img class="lock" src="@/assets/img/icon/lock.png" alt=""></div>
                  </el-tooltip> -->
                  <span v-if="isPC&&showVolume&&!product.afterDiscountAmount" class="salesVolume f-b">{{product.salesVolume}} {{ $t('Components.Product.Sales') }}</span>
                </p>
              </template>
            </template>
            <template v-else>
              <template v-if="product.afterDiscountAmount >= 0">
                <template>
                  <el-tooltip effect="dark" :content="`Wholesale Price ${currencySymbol}${countCurrencyConversion(product.afterDiscountAmount)}`" placement="bottom-start">
                    <!-- <p class="wsp">WSP {{ currencySymbol }}{{product.afterDiscountAmount | currencyConversion}}</p> -->
                    <div class="mobile-price product-price wsp">
                      <div class="price-with-discountPrice">WSP {{ currencySymbol }}{{product.afterDiscountAmount | currencyConversion}}</div>
                      <div v-if="isShowSaleCount" class="salesVolume">{{product.salesVolume}} {{ $t('Components.Product.Sales') }}</div>
                    </div>
                  </el-tooltip>
                  <p class="discount-price-mt-origin f--c" v-if="isShowSalePrice">
                    {{ currencySymbol }}{{product.price || product.minPrice | currencyConversion}}
                  </p>
                </template>
                <!-- <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                  <div class="f--c pointer">WSP <img class="lock" src="@/assets/img/icon/lock.png" alt=""></div>
                </el-tooltip> -->
              </template>
              <template v-else>
                <el-tooltip effect="dark" :content="`Wholesale Price ${currencySymbol}${countCurrencyConversion(product.price || product.minPrice)}`" placement="bottom-start">
                  <p class="product-price">WSP {{ currencySymbol }}{{product.price || product.minPrice | currencyConversion}}</p>
                </el-tooltip>
                <!-- <el-tooltip v-else effect="dark" :content="$t('Components.Product.LoginHint')" placement="bottom-start">
                  <div class="f--c pointer">WSP <img class="lock" src="@/assets/img/icon/lock.png" alt=""></div>
                </el-tooltip> -->
              </template>
            </template>
          </div>
        </div>
        <!-- <div class="flashProgress" v-if="isShowProgress">
          <el-progress :text-inside="true" :percentage="spikeProgress" color="#FFA154" :stroke-width="8"></el-progress>
        </div>
        <div v-if="isPC && (showVolume&&product.discountType&& product.discountType === 1) && $route.path !== '/product-list'" class="salesVolume">{{product.salesVolume}} {{ $t('Components.Product.Sales') }}</div> -->
        <!-- <div v-if="isPC&&showVolume&&product.afterDiscountAmount >= 0" class="salesVolume">{{product.salesVolume}} Sales</div> -->
        <!-- <div v-if="productInfoVisible" class="volume stockNum">{{$t('publishListings.Inventory')}} {{product.stock}}</div> -->
      </div>
    </div>
    <!-- 移动端 -->
    <!-- <div v-else class="mobile-product">
      <div v-if="isShowCollectionBut&&showCollection" class="product-collection" :style="{ background: +this.product.collectStatus === 1 ? 'none' : 'rgba(0, 0, 0, 0.17)'}" @click.stop="collectionProduct">
        <i class="iconfont" :class="[+this.product.collectStatus === 1 ? 'icon-heart-3-fill' : 'icon-heart-3-line']"></i>
      </div>
      <div v-if="published" class="published">
        {{$t('customProduct.Published')}}
      </div>
      <oss-img :src="product.imgUrl || product.images" :width="31" :height="42" class="product-img" style="border-radius:4px;" />
      <p class="product-price" v-if="isShowInfo">${{product.price || product.minPrice | money}}</p>
      <p class="product-name ellipsis" v-if="isShowInfo">{{product.productName}}</p>
    </div> -->
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'

// SHOPIFY("SP", "Shopify"),
// KAKACLO("KA", "Kakaclo"),
// SHOPLAZZA("DJ","Shoplazza"),
// SHOPLINE("SL","shopLine");
export default {
  props: {
    product: {
      type: Object,
      default: () => { }
    },
    productInfoVisible: { // 是否显示商品销量和库存
      type: Boolean,
      default: false
    },
    jumpPath: {
      type: String,
      default: ''
    },
    showVolume: {
      type: Boolean,
      default: true
    },
    currentWarehouse: {
      type: String,
      default: ''
    },
    isShowName: {
      type: Boolean,
      default: true
    },
    isShowSalePrice: {
      type: Boolean,
      default: true
    },
    isShowSaleCount: {
      type: Boolean,
      default: false
    },
    isShowProgress: {
      type: Boolean,
      default: false
    },
    isLazy: {
      type: Boolean,
      default: true
    },
    kklocation: {
      type: String,
      default: ''
    },
    reportType: {
      type: String,
      default: ''
    },
    noChangeWarehouse: {
      type: Boolean,
      default: false
    },
    isShowInfo: {
      type: Boolean,
      default: true
    },
    showCollection: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      icon: {
        'SP': require('@/assets/img/shopify.png'),
        'KA': require('@/assets/img/kakaclo-store.png'),
        'DJ': require('@/assets/img/Shoplazza.png'),
        'SL': require('@/assets/img/shopline.png')
      }
    }
  },
  computed: {
    isShowCollectionBut() {
      return !!this.$store.state.common.token
    },
    published() {
      return _.isNonEmptyArray(this.product.storeList)
    },
    isNew() {
      return (date) => {
        return date > (Date.now() - 29 * 24 * 60 * 60 * 1000)
      }
    },
    currencyRate() {
      return this.$store.state.common.currencyRate
    },
    currencySymbol() {
      return this.$store.state.common.currencySymbol
    },
    currency() {
      return this.$store.state.common.currency
    },
    spikeProgress() {
      if (Number.isNaN(parseInt(this.product.spikeSoldStock / this.product.spikeTotalStock * 100))) return 0
      return parseInt(this.product.spikeSoldStock / this.product.spikeTotalStock * 100)
    },
    isSoldOut() {
      if ([0, 4].includes(this.product.productStatus)) return true
      if (!this.product.stock) return true
      if (this.product.discountType && this.product.discountType === 1 && this.product.spikeSoldStock >= this.product.spikeTotalStock) return true
      return false
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  mounted() {
  },

  methods: {
    collectionProduct() {
      if (Number(this.product.collectStatus) === 1) {
        API.publishGetProductDelete([this.product.kkProductId]).then(res => {
          this.$message.success('Successfully removed from your favorites!')
        })
      } else {
        API.addProductList(this.product.kkProductId).then(res => {
          this.$message.success('Successfully saved to your favorites!')
        })
      }
      this.$set(this.product, 'collectStatus', Number(this.product.collectStatus) === 1 ? 0 : 1)
    },
    toProductDetail(id) {
      if (this.jumpPath) {
        this.$router.push(this.jumpPath)
      } else {
        this.$record({
          eventType: 'click',
          eventId: `${this.$route.meta.pageId}_${this.kklocation}_click`,
          value: JSON.stringify({ kkProductId: id })
        })
        if (this.reportType === 'activity') {
          this.$record({
            eventType: 'click',
            eventId: `allActivityProduct_click`,
            value: JSON.stringify({ discountId: this.product.discountId, type: 'activity' })
          })
        }
        // let path = `/mall/product-detail?id=${id}`
        // if (this.product.color) path += `&color=${this.product.color}`
        // if (this.currentWarehouse) {
        //   path += `&warehouse=${this.currentWarehouse}`
        // }
        // if (this.noChangeWarehouse) {
        //   path += `&noChangeWarehouse=1`
        // }
        // window.open(path)

        this.jumpDetailSeo(id, this.product.color, this.currentWarehouse, this.noChangeWarehouse)
      }
    },
    countCurrencyConversion(value) {
      if (!value || typeof value !== 'number') return value
      let rate = this.$store.state.common.currencyRate * 10000
      return (value * 10000 * rate / 100000000).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-single {
  width: 100%;
  position: relative;
  .product-collection {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    position: absolute;
    right: 8px;
    top: 8px;
    justify-content: center;
    align-items: center;
    z-index: 1;

    i {
      font-size: 18px;
    }
    .icon-heart-3-line {
      color: white;
    }
    .icon-heart-3-fill {
      color: #ed5a56;
    }
  }
  .product-img {
    position: relative;
    border-radius: 4px;
    width: 100%;
    height: 0;
    padding-bottom: 132%;
    background: #fff;
    overflow: hidden;
    img {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }
    .published {
      position: absolute;
      left: 5px;
      bottom: 8px;
      font-weight: 400;
      font-size: 12px;
      line-height: 26px;
      background: rgba(0, 0, 0, 0.63);
      color: white;
      padding: 0 12px;
      border-radius: 330px;
    }
    .published:hover + .published-list {
      display: block;
    }
    .published-list {
      position: absolute;
      bottom: 40px;
      left: 5px;
      background: rgba(0, 0, 0, 0.53);
      box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
      border-radius: 6px;
      padding: 13px 8px;
      max-height: 150px;
      width: 100px;
      overflow: auto;
      display: none;
      .published-item {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: white;
        margin-bottom: 10px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
      }
    }
  }
  .product-info {
    width: 100%;
    .product-name {
      color: #606266;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      padding: 4px 0 8px;
    }
    .product-price {
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
    }
    .volume {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #747a87;
    }
    .stockNum {
      padding-top: 8px;
      margin-top: 8px;
      border-top: 1px solid #cdd4dd;
    }
    .discount-price {
      .price-with-discountPrice > span:first-child {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #f36d6f;
      }
      .price-with-discountPrice > span:last-child {
        font-weight: 400;
        font-size: 12px;
        color: #909399;
        padding: 0 15px 0 10px;
        text-decoration: line-through;
      }
    }
    .discount-price-mt-discount {
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: #e84553;
    }
    .discount-price-mt-origin {
      font-weight: 400;
      font-size: 12px;
      color: #909399;
      // padding: 0 15px 0 10px;
      text-decoration: line-through;
    }
    .salesVolume {
      font-weight: 400;
      font-size: 12px;
      line-height: 142%;
      color: #909399;
    }
    .flashProgress {
      margin: 4px 0;
      /deep/.el-progress-bar__innerText {
        display: none !important;
      }
    }
    .lock {
      width: 18px;
      margin-left: 4px;
    }
  }
  .reduction-flash {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 9;
    // background: #e53353;
    color: white;
    font-size: 12px;
    // width: 37px;
    // height: 19px;
    border-radius: 4px;
  }
  .reduction {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 9;
    background: #f36d6f;
    color: white;
    font-size: 12px;
    width: 45px;
    height: 20px;
    line-height: 20px;
  }
  .soldOut {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    right: 0;
    width: 80%;
    bottom: 6px;
    text-align: center;
    background-color: #f4f6f9;
    border-radius: 6px;
    color: #8b93a3;
    height: 30px;
    line-height: 30px;
  }
}

/** 图片鼠标上移放大缩小 */
.product-single:hover .product-collection {
  display: flex !important;
}
.product-single:hover .product-img > img,
.product-single:hover .product-img /deep/ img {
  transition: transform 0.6s;
  transform: scale(1.3);
}
.product-img > img,
.product-img /deep/ img {
  transition: transform 0.6s;
}
.new-icon {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 9;
  span {
    display: inline-block;
    line-height: 20px;
    width: 45px;
    height: 20px;
    background: #9ac331;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    flex-shrink: 0;
  }
}
.reduction-flash {
  span {
    display: inline-block;
    line-height: 20px;
    width: 45px;
    height: 20px;
    background: #f36d6f;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
    color: #fff;
    flex-shrink: 0;
  }
}
/** 图片鼠标上移放大缩小 */
.supplier-level {
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 2px;
}
.mobile-price {
  display: flex;
  justify-content: space-between;
  font-size: 14px !important;
  color: #303133 !important;
  font-weight: 500 !important;
  line-height: 22px !important;
  .price-with-discountPrice {
    color: #f36d6f;
  }
}
</style>
<style lang="scss" scoped>
// .mobile-product {
//   display: inline-block;
//   position: relative;
//   width: 3.3rem;
//   overflow: hidden;
//   margin-bottom: .32rem;
//   .product-collection{
//     width: .6rem;
//     height: .6rem;
//     border-radius: 100%;
//     position: absolute;
//     right: .16rem;
//     top: .16rem;
//     justify-content: center;
//     align-items: center;
//     z-index: 1;
//     display: flex;

//     i{
//       font-size: .32rem;
//     }
//     .icon-heart-3-line{
//       color: white;
//     }
//     .icon-heart-3-fill{
//       color: #ED5A56;
//     }
//   }
//   .product-img {
//     width: 100%;
//     height: 4.36rem;
//     object-fit: cover;
//     border-radius: .12rem;
//   }
//   .product-price {
//     font-size: .32rem;
//     font-weight: 500;
//     line-height: .5rem;
//   }
//   .product-name {
//     color: #10141d;
//     font-size: .28rem;
//     line-height: .5rem;
//   }
//   .published{
//     position: absolute;
//     left: .1rem;
//     top: 3.85rem;
//     font-weight: 400;
//     font-size: .24rem;
//     line-height: .4rem;
//     background: rgba(0, 0, 0, 0.63);
//     color: white;
//     padding: .02rem .15rem;
//     border-radius: 330px;
//   }
// }
</style>

<style lang="scss">
.porduct-like {
  min-width: 50px;
  padding: 2px 5px;
  border: 0.5px solid #aaa;
}
</style>

